export const PARITY_OFFER_MODES = ['custom', 'paritydeals', 'off'] as const;

export type ParityOfferMode = (typeof PARITY_OFFER_MODES)[number];

export type ParityOfferTierId = 'regional30' | 'regional20';

export interface ParityOffer {
  countryCode: string;
  /** Display name phrased to read after "in" — "the Philippines", "the UAE". */
  countryName: string;
  tierId: ParityOfferTierId;
  percentOff: 20 | 30;
  couponCode: string;
  duration: 'forever';
}
